/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M15.0001 17L18.0001 14M15.0001 17L12.0001 14M15.0001 17V12.4C15.0001 10.1598 15.0001 9.03968 14.5641 8.18404C14.1806 7.43139 13.5687 6.81947 12.816 6.43597C11.9604 6 10.8403 6 8.60008 6H7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M15.0001 17L18.0001 14M15.0001 17L12.0001 14M15.0001 17V13.5001C15.0001 11.1703 15.0001 10.0054 14.6195 9.08653C14.112 7.86143 13.1386 6.88809 11.9136 6.38063C10.9947 6 9.82978 6 7.5 6V6H7M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM8.60002 6.75C9.7325 6.75 10.5368 6.75058 11.1661 6.80201C11.7868 6.85271 12.171 6.94909 12.4755 7.10423C13.087 7.41582 13.5842 7.913 13.8958 8.52453C14.0509 8.829 14.1473 9.21325 14.198 9.83388C14.2494 10.4633 14.25 11.2675 14.25 12.4V15.1893L12.5303 13.4697C12.2375 13.1768 11.7626 13.1768 11.4697 13.4697C11.1768 13.7626 11.1768 14.2374 11.4697 14.5303L14.4697 17.5303C14.7626 17.8232 15.2375 17.8232 15.5303 17.5303L18.5303 14.5303C18.8232 14.2374 18.8232 13.7626 18.5303 13.4697C18.2375 13.1768 17.7626 13.1768 17.4697 13.4697L15.75 15.1893V12.4V12.367V12.367C15.75 11.2748 15.75 10.4093 15.693 9.71173C15.6347 8.99834 15.5131 8.39472 15.2323 7.84354C14.7769 6.94978 14.0502 6.22312 13.1565 5.76772C12.6053 5.48688 12.0017 5.36527 11.2883 5.30699C10.5907 5.24999 9.72517 5.24999 8.63303 5.25H8.63302H8.60002H6.99994C6.58573 5.25 6.24994 5.58579 6.24994 6C6.24994 6.41421 6.58573 6.75 6.99994 6.75H8.60002Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M15.0001 17L18.0001 14M15.0001 17L12.0001 14M15.0001 17V13.5001C15.0001 11.1703 15.0001 10.0054 14.6195 9.08653C14.112 7.86143 13.1386 6.88809 11.9136 6.38063C10.9947 6 9.82978 6 7.5 6V6H7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M15.0001 17L18.0001 14M15.0001 17L12.0001 14M15.0001 17V13.5001C15.0001 11.1703 15.0001 10.0054 14.6195 9.08653C14.112 7.86143 13.1386 6.88809 11.9136 6.38063C10.9947 6 9.82978 6 7.5 6V6H7M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.1662 6.80201C10.5368 6.75058 9.73256 6.75 8.60008 6.75H7C6.58579 6.75 6.25 6.41421 6.25 6C6.25 5.58579 6.58579 5.25 7 5.25H8.60008L8.63308 5.25C9.72522 5.24999 10.5907 5.24999 11.2883 5.30699C12.0017 5.36527 12.6054 5.48688 13.1565 5.76772C14.0503 6.22312 14.777 6.94978 15.2324 7.84355C15.5132 8.39472 15.6348 8.99835 15.6931 9.71173C15.7501 10.4094 15.7501 11.2748 15.7501 12.367V12.4V15.1893L17.4698 13.4697C17.7626 13.1768 18.2375 13.1768 18.5304 13.4697C18.8233 13.7626 18.8233 14.2374 18.5304 14.5303L15.5304 17.5303C15.2375 17.8232 14.7626 17.8232 14.4697 17.5303L11.4697 14.5303C11.1769 14.2374 11.1769 13.7626 11.4697 13.4697C11.7626 13.1768 12.2375 13.1768 12.5304 13.4697L14.2501 15.1893V12.4C14.2501 11.2675 14.2495 10.4633 14.1981 9.83388C14.1474 9.21325 14.051 8.829 13.8959 8.52453C13.5843 7.913 13.0871 7.41582 12.4755 7.10423C12.1711 6.94909 11.7868 6.85271 11.1662 6.80201Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
